import { render, staticRenderFns } from "./DropdownNavigation.vue?vue&type=template&id=39dacabc&"
import script from "./DropdownNavigation.vue?vue&type=script&lang=ts&"
export * from "./DropdownNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports